import React from "react";
import { ApplyDocumentViewItem } from "../Components/ApplyDocumentDrawer";
import { ApplicantInfo, EvaluationViewpoint } from "./ScoringPage";
import { ScoringTable1 } from "./ScoringTable1";
import { ScoringTable2 } from "./ScoringTable2";
import { ScoringTable3 } from "./ScoringTable3";
import { ScoringTable4 } from "./ScoringTable4";
import { ScoringTable5 } from "./ScoringTable5";
import { ScoringTable6 } from "./ScoringTable6";
import { ScoringTable7 } from "./ScoringTable7";
import { ScoringTable8 } from "./ScoringTable8";
import { ScoringTable9 } from "./ScoringTable9";

export interface ScoringTableProps {
  showPersonInfo: boolean;
  showPersonInfoItemFlags: string[];
  pattern: string;
  useCase: string; // 1:採点担当者採点、2:採点確定、3:スーパー修正、4:閲覧
  scoringType: string; // 1：答案、2：面接
  evaluations: EvaluationViewpoint[];
  applicants: ApplicantInfo[];
  onDocumentLinkClick: (documents?: ApplyDocumentViewItem[]) => void;
  setFormFiledValue: (name: string, value: any) => void;
  getFormFiledValue?: (name: string) => any;
  afMap: Map<string, boolean>;
}

export const ScoringTable = ({
  showPersonInfo,
  showPersonInfoItemFlags,
  pattern,
  useCase,
  scoringType,
  evaluations,
  applicants,
  onDocumentLinkClick,
  setFormFiledValue,
  getFormFiledValue,
  afMap,
}: ScoringTableProps) => {
  React.useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  switch (pattern) {
    case "1":
      return (
        <ScoringTable1
          pattern={pattern}
          showPersonInfo={showPersonInfo}
          showPersonInfoItemFlags={showPersonInfoItemFlags}
          useCase={useCase}
          scoringType={scoringType}
          evaluations={evaluations}
          applicants={applicants}
          onDocumentLinkClick={onDocumentLinkClick}
          setFormFiledValue={setFormFiledValue}
          afMap={afMap}
        />
      );
    case "2":
      return (
        <ScoringTable2
          pattern={pattern}
          showPersonInfo={showPersonInfo}
          showPersonInfoItemFlags={showPersonInfoItemFlags}
          useCase={useCase}
          scoringType={scoringType}
          evaluations={evaluations}
          applicants={applicants}
          onDocumentLinkClick={onDocumentLinkClick}
          setFormFiledValue={setFormFiledValue}
          afMap={afMap}
        />
      );
    case "3":
      return (
        <ScoringTable3
          pattern={pattern}
          showPersonInfo={showPersonInfo}
          showPersonInfoItemFlags={showPersonInfoItemFlags}
          useCase={useCase}
          scoringType={scoringType}
          evaluations={evaluations}
          applicants={applicants}
          onDocumentLinkClick={onDocumentLinkClick}
          setFormFiledValue={setFormFiledValue}
          afMap={afMap}
        />
      );
    case "4":
      return (
        <ScoringTable4
          pattern={pattern}
          showPersonInfo={showPersonInfo}
          showPersonInfoItemFlags={showPersonInfoItemFlags}
          useCase={useCase}
          scoringType={scoringType}
          evaluations={evaluations}
          applicants={applicants}
          onDocumentLinkClick={onDocumentLinkClick}
          setFormFiledValue={setFormFiledValue}
          afMap={afMap}
        />
      );
    case "5":
      return (
        <ScoringTable5
          pattern={pattern}
          showPersonInfo={showPersonInfo}
          showPersonInfoItemFlags={showPersonInfoItemFlags}
          useCase={useCase}
          scoringType={scoringType}
          evaluations={evaluations}
          applicants={applicants}
          onDocumentLinkClick={onDocumentLinkClick}
          setFormFiledValue={setFormFiledValue}
          afMap={afMap}
        />
      );
    case "6":
      return (
        <ScoringTable6
          pattern={pattern}
          showPersonInfo={showPersonInfo}
          showPersonInfoItemFlags={showPersonInfoItemFlags}
          useCase={useCase}
          scoringType={scoringType}
          evaluations={evaluations}
          applicants={applicants}
          onDocumentLinkClick={onDocumentLinkClick}
          setFormFiledValue={setFormFiledValue}
          afMap={afMap}
        />
      );
    case "7":
      return (
        <ScoringTable7
          pattern={pattern}
          showPersonInfo={showPersonInfo}
          showPersonInfoItemFlags={showPersonInfoItemFlags}
          useCase={useCase}
          scoringType={scoringType}
          evaluations={evaluations}
          applicants={applicants}
          onDocumentLinkClick={onDocumentLinkClick}
          setFormFiledValue={setFormFiledValue}
          afMap={afMap}
        />
      );
    case "8":
      return (
        <ScoringTable8
          pattern={pattern}
          showPersonInfo={showPersonInfo}
          showPersonInfoItemFlags={showPersonInfoItemFlags}
          useCase={useCase}
          scoringType={scoringType}
          evaluations={evaluations}
          applicants={applicants}
          onDocumentLinkClick={onDocumentLinkClick}
          setFormFiledValue={setFormFiledValue}
          afMap={afMap}
        />
      );
    case "9":
      return (
        <ScoringTable9
          pattern={pattern}
          showPersonInfo={showPersonInfo}
          showPersonInfoItemFlags={showPersonInfoItemFlags}
          useCase={useCase}
          scoringType={scoringType}
          evaluations={evaluations}
          applicants={applicants}
          onDocumentLinkClick={onDocumentLinkClick}
          setFormFiledValue={setFormFiledValue}
          getFormFiledValue={getFormFiledValue}
          afMap={afMap}
        />
      );
    default:
      return <></>;
  }
};
